<template>
  <v-container fluid>
    <h2>{{ $tt('customFieldRegistration') }}</h2>
    <div>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card class="flexcard" height="100%" outlined>
            <v-card-title>{{ $tt('customFieldUploadTitle') }}</v-card-title>
            <v-card-text class="text--primary">{{ $tt('customFieldUploadMessage') }}</v-card-text>
            <v-card-text class="grow">
              <v-card class="mx-3 mb-3 pa-3" outlined>
                <v-card-text class="text--primary">
                  <p>{{ $tt('customFileUploadShapefileDescription') }}</p>
                  <ul class="mb-4">
                    <li>{{ $tt('customFileUploadShpDescription') }}</li>
                    <li>{{ $tt('customFileUploadShxDescription') }}</li>
                    <li>{{ $tt('customFileUploadDbfDescription') }}</li>
                    <li>{{ $tt('customFileUploadPrjDescription') }}</li>
                  </ul>
                  <v-alert border="top" colored-border elevation="2" type="warning">{{
                    $tt('customFileUploadPrjCaution')
                  }}</v-alert>
                </v-card-text>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-btn block color="primary" :to="{ name: 'FieldImport' }">{{ $tt('customUpload') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card class="flexcard" height="100%" outlined>
            <v-card-title>{{ $tt('customFieldCreateWithMapTitle') }}</v-card-title>
            <v-card-text class="text--primary">{{ $tt('customFieldCreateWithMapTitleDescription') }}</v-card-text>
            <v-card-text class="grow">
              <v-img :src="createFieldImgSrc" />
            </v-card-text>
            <v-card-actions>
              <v-btn block color="primary" :to="{ name: 'FieldCreate' }">{{
                $tt('customFieldCreateWithMapButton')
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import storage from '@/lib/storage'

export default {
  name: 'FieldAdd',

  methods: {
    isLanguage(lang) {
      return storage.getUserLangConsideringDefault() === lang
    },
  },

  computed: {
    createFieldImgSrc() {
      return '/images/create_field_on_the_map_' + storage.getUserLangConsideringDefault() + '.png'
    },
  },
}
</script>

<style scoped>
.flexcard {
  display: flex;
  flex-direction: column;
}
</style>
